import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout";
import Index from "../views/HomeIndex.vue";
import Intro from "../views/intro.vue";
import Case from "../views/case.vue";
import NewDetail from "../views/newDetail.vue";
import Contact from "../views/contact.vue";
import Join from "../views/join.vue";
import Business from "../views/business.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "/",
        name: "index",
        component: Index,
      },
      {
        path: "/intro",
        name: "intro",
        component: Intro,
      },
      {
        path: "/case",
        name: "case",
        component: Case,
      },
      {
        path: "/caseDetail/:id",
        name: "CaseDetail",
        component: NewDetail,
      },
      {
        path: "/newDetail/:id",
        name: "NewDetail",
        component: NewDetail,
      },
      {
        path: "/contact",
        name: "contact",
        component: Contact,
      },
      {
        path: "/join",
        name: "join",
        component: Join,
      },
      {
        path: "/business/:key",
        name: "business",
        component: Business,
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
